import { create } from 'zustand';

const useNotificationStore = create((set) => ({
  open: false,
  message: '',
  severity: 'info', // 'error', 'warning', 'info', 'success'

  showNotification: (message, severity = 'info') => {
    set({ message, severity, open: true });
  },

  hideNotification: () => {
    set({ open: false });
  },
}));

export default useNotificationStore;
